import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IClinicalParameter;

const clinicalParameterSlice = createSlice({
    name: "clinicalParameter",
    initialState,
    reducers: {
        setClinicalParameter: (state, action: PayloadAction<IClinicalParameter | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setClinicalParameter } = clinicalParameterSlice.actions;
export default clinicalParameterSlice.reducer;

export const getClinicalParameter = (state: RootState) => state.clinicalParameter;
